import {
  editStrategyAction,
  newStrategyAction,
} from "fleet/redux-store/strategies";
import {
  resetUiRedirectAction,
  updateUiStrategyAction,
} from "fleet/redux-store/ui-state/strategy-v2";
import { StrategyV2Detail } from "fleet/view/strategy-v2/detail";
import { connect } from "react-redux";
import { getAuthUser } from "redux-store/auth";

function mapStateToProps(state) {
  const user = getAuthUser(state);
  const { global, pages } = state;

  return {
    user,
    applications: global.applications,
    redirectTo: pages.strategyDetail.redirectTo,
    currentStrategy: pages.strategyDetail.strategy,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    newStrategy: (strategy) => {
      dispatch(newStrategyAction(strategy, "Success! New strategy created."));
    },
    editStrategy: (id, strategy) => {
      dispatch(editStrategyAction(id, strategy, "Success! Strategy edited."));
    },
    resetUiRedirect: () => {
      dispatch(resetUiRedirectAction);
    },
    setUiStrategy: (dnStrategy) => {
      dispatch(updateUiStrategyAction(dnStrategy));
    },
  };
}

const ConnectedStrategyV2Detail = connect(
  mapStateToProps,
  mapDispatchToProps,
)(StrategyV2Detail);

export { ConnectedStrategyV2Detail };
